module.exports = __webpack_public_path__ + "static/hagley-road-map.a5956cbe.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/ThePlatform/hagley-road-map.png
// module id = 458
// module chunks = 145206920446059